module.exports = __webpack_public_path__ + "e70d04c9a63113ec002d3220090b674f.png";